export const CLASS_ACTIVE = 'is-active';
export const CLASS_OPEN = 'is-open';
export const CLASS_PAUSED = 'is-paused';
// export const CLASS_CLOSED = 'is-closed';
export const CLASS_HIDDEN = 'is-hidden';
// export const CLASS_VISIBLE = 'is-visible';
// export const CLASS_FADE_IN = 'is-fade-in';
// export const CLASS_FADE_OUT = 'is-fade-out';
// export const CLASS_STICKY = 'is-sticky';
// export const CLASS_FIXED = 'is-fixed';
// export const CLASS_UNAVAILABLE = 'is-unavailable';
export const CLASS_SELECTED = 'is-selected';
export const CLASS_DISABLED = 'is-disabled';
export const CLASS_SCROLL_DISABLED = 'is-scroll-disabled';
export const CLASS_HAS_ERROR = 'has-error';
// export const CLASS_MENU_TOGGLE = 'is-menu-open';
export const CLASS_INITIALISED = 'is-initialised';
export const CLASS_THUMB_INITIALISED = 'is-thumbnail-initialised';
// export const CLASS_PENDING = 'is-pending';
// export const CLASS_FILTERED = 'is-filtered';
// export const CLASS_lOADING = 'is-loading';
// export const CLASS_LOADED = 'is-loaded';
// export const CLASS_CART_PENDING = 'is-cart-pending';
export const CLASS_DRAWER_OPEN = 'is-drawer-open';
export const CLASS_MENU_HOVER = 'is-menu-hover';
export const CLASS_SEARCH_OPEN = 'is-search-open';
export const CLASS_CART_PENDING = 'is-cart-pending';
export const CLASS_HAS_VALUE = 'has-value';
export const CLASS_HAS_ITEMS = 'has-items';
export const CLASS_VISIBLE = 'is-visible';
export const CLASS_FILLING = 'is-filling';
export const CLASS_FILLED = 'is-filled';
export const CLASS_TOGGLED = 'is-toggled';
export const CLASS_HOVER = 'is-hover';
export const CLASS_NEXT_ACTIVE = 'is-next-active';
export const CLASS_PREV_ACTIVE = 'is-prev-active';
export const CLASS_CAROUSEL_BEGINNING = 'carousel-beginning';
export const CLASS_CAROUSEL_END = 'carousel-end';

export const CLASS_REBUY_VISIBLE = 'rebuy-modal-visible';